import { PartFileStandaloneViewerData } from '@frontend/api';

export const types = {
  INIT_FILE_VIEWER: 'modules/fileViewer/INIT_FILE_VIEWER',
  UPDATE_ITAR_STATUS: 'modules/fileViewer/UPDATE_ITAR_STATUS',
};

type UpdateItarStatusPayload = {
  partFileUuid: string;
  isExportControlled: boolean;
};

export const fileViewer = {
  init: ({
    activeRootFile,
  }: {
    activeRootFile: PartFileStandaloneViewerData;
  }) => ({
    type: types.INIT_FILE_VIEWER,
    payload: { activeRootFile },
  }),
  updateItarStatus: ({
    partFileUuid,
    isExportControlled,
  }: UpdateItarStatusPayload) => ({
    type: types.UPDATE_ITAR_STATUS,
    payload: { partFileUuid, isExportControlled },
  }),
};
